import React from 'react';
import PropTypes from 'prop-types';
import Scrollspy from 'react-scrollspy';
import { EMPLOYER_OFFSET_TOP } from 'consts';

class HeaderScroll extends React.Component {
  sectionLabels = [];

  renderSections = sections => {
    let menuSections = sections.map(element => {
      this.sectionLabels.push(element.viewId);
      return (
        <li
          className="nav-item"
          key={element.viewId}
          ref={this[element.viewId]}
        >
          <button
            data-id="header-scroll-btn"
            data-scroll-to={element.viewId}
            tabIndex={0}
            className="scroll-to-btn px-sm-3 py-2"
            onClick={this.handleOnClick}
          >
            {element.label}
          </button>
        </li>
      );
    });
    return menuSections;
  };

  handleOnClick = event => {
    const scrollTo = event.target.dataset.scrollTo;
    const element = document.getElementById(scrollTo);
    const sectionLocation = element.offsetTop - EMPLOYER_OFFSET_TOP;
    const scrollToTop = scrollTo === this.sectionLabels[0];
    window.scrollTo({
      top: scrollToTop ? 0 : sectionLocation,
      behavior: 'smooth',
    });
  };

  render() {
    let menuOptions = this.renderSections(this.props.sections);
    return (
      <Scrollspy
        items={this.sectionLabels}
        currentClassName="active"
        className="header-scroller"
        offset={-200}
      >
        {menuOptions}
      </Scrollspy>
    );
  }
}
HeaderScroll.propTypes = {
  sections: PropTypes.array.isRequired,
};

export default HeaderScroll;
